import { useFeatureValue } from '@growthbook/growthbook-react'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import { ReactBlocks } from 'app/helpers/Blocks'

export interface IAttributes {
  experimentKey: string
  defaultVariant: string
  variant: string
}

const GrowthBookVariant: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  const value = useFeatureValue(attributes.experimentKey, attributes.defaultVariant)

  if (value !== attributes.variant) {
    return null
  }

  return <ReactBlocks innerBlocks={props.innerBlocks} />
}

export default GrowthBookVariant
